const state = {
  datatimelist: [],
};
const mutations = {
  SETDATATIME(state, newdatatime) {
    state.datatimelist = newdatatime
  }

};
const actions = {
  updateDatetime({ commit }, newdatatime) {
    commit("SETDATATIME", newdatatime)
  }
};
export default {
  state,
  mutations,
  actions,
}